export const PERSONALIZATIONS_ENTITY_SUBSCRIBE_START =
	'PERSONALIZATIONS_ENTITY_SUBSCRIBE_START';
export const PERSONALIZATIONS_ENTITY_SUBSCRIBE_SUCCESS =
	'PERSONALIZATIONS_ENTITY_SUBSCRIBE_SUCCESS';
export const PERSONALIZATIONS_ENTITY_SUBSCRIBE_ERROR =
	'PERSONALIZATIONS_ENTITY_SUBSCRIBE_ERROR';
export const PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_START =
	'PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_START';
export const PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_SUCCESS =
	'PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_SUCCESS';
export const PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_ERROR =
	'PERSONALIZATIONS_ENTITY_UNSUBSCRIBE_ERROR';
export const PERSONALIZATIONS_THEMATIC_SUBSCRIBE_START =
	'PERSONALIZATIONS_THEMATIC_SUBSCRIBE_START';
export const PERSONALIZATIONS_THEMATIC_SUBSCRIBE_SUCCESS =
	'PERSONALIZATIONS_THEMATIC_SUBSCRIBE_SUCCESS';
export const PERSONALIZATIONS_THEMATIC_SUBSCRIBE_ERROR =
	'PERSONALIZATIONS_THEMATIC_SUBSCRIBE_ERROR';
export const PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_START =
	'PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_START';
export const PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_SUCCESS =
	'PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_SUCCESS';
export const PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_ERROR =
	'PERSONALIZATIONS_THEMATIC_UNSUBSCRIBE_ERROR';
export const PERSONALIZATIONS_GET_ME_START = 'PERSONALIZATIONS_GET_ME_START';
export const PERSONALIZATIONS_GET_ME_SUCCESS =
	'PERSONALIZATIONS_GET_ME_SUCCESS';
export const PERSONALIZATIONS_GET_ME_ERROR = 'PERSONALIZATIONS_GET_ME_ERROR';
